const text = `[[topSection]]En [[publisherName]] creemos que su privacy online es importante. Por lo tanto, queremos informarle de lo siguiente: 

Almacenamos cierta información en su dispositivo para que este sitio web funcione. [[thirdPartiesUrl]] también pueden acceder a su dispositivo para almacenar información similar. 

Tanto nosotros como [[thirdPartiesUrl]] podemos usar datos personales como su dirección IP y sus ID de usuario único para los siguientes propósitos, para los cuales [[thirdPartiesUrl]] pueden solicitar su consentimiento:
[[purposes]]

Propósitos para los cuales [[thirdPartiesUrl]] reclaman interés legítimo sin derecho a objetar:
[[legitimateInterest]]

Y características por las cuales [[thirdPartiesUrl]] requieren explícitamente su aceptación:
[[features]]

Proporcionamos esta interfaz para que pueda controlar su configuración de privacidad. Puede cambiar su configuración de privacidad en cualquier momento mientras visita nuestro sitio web. Para abrir este cuadro de diálogo, navegue hasta el botón Privacidad en su pantalla. 

Además de solicitar su consentimiento, [[thirdPartiesUrl]] pueden reclamar [[legitimateInterestUrl]] como base legal para el procesamiento de datos personales. En la mayoría de los casos, tiene derecho a oponerse. Este administrador de privacidad proporciona una opción para transmitir su objeción a un "tercero". 

Retener el consentimiento puede llevar a la generación de un mayor número de anuncios y de anuncios que no se adaptan a sus intereses. 

El ámbito de aplicación de cualquier consentimiento, objeción y aceptación que usted de está limitado a este sitio web.
[[bottomSection]]
`;
export default text;